import * as Icons from '../../constants/icons';

import { LayersControl, Map } from 'react-leaflet';
import React, { createRef, useEffect, useRef, useState } from 'react';

import { CategoryRadio } from './CategoryRadio';
import { GoogleLayer } from 'react-leaflet-google-v2';
import Hammer from 'hammerjs';
import { Incidents } from './Incidents';
import { MapStyles } from './MapStyles';
import gsap from 'gsap/gsap-core';
import incidentsData from './content/incidents';
import regions from './content/regions';

const key = 'AIzaSyDELI8qLOVLDKfM6XggxIgtxKL06Q_pzzA';

export const IncidentsMap = (props) => {
    const wa = regions[0];
    const map = createRef();
    const regionSelect = createRef();
    const incidentTypeRadio = createRef();
    const initialPosition = [wa.lat, wa.lng];
    const [activeCategory, setActiveCategory] = useState(incidentsData[0].id);
    // const [controlsCollapsed, setControlsCollapsed] = useState(false);
    const initialZoom = wa.zoom;
    const controlsCollapsed = useRef(false);
    const mapControls = createRef();
    const toggleButton = createRef();
    // console.log('activeCategory: ', activeCategory);

    useEffect(() => {
        //Region selectbox
        const handleRegionChange = (e) => {
            const region = regions.find((item) => item.value === e.target.value);
            map.current.leafletElement.flyTo([region.lat, region.lng], region.zoom, { animate: true, duration: 0.2 });
        };

        //Incident type radio
        const typeChange = (e) => {
            const value = e.target.value;
            const leafletCheckboxes = document.querySelectorAll('.leaflet-control-layers-overlays input[type="checkbox"]');
            for (var index = 0; index < leafletCheckboxes.length; index++) {
                const el = leafletCheckboxes[index];
                if (el.checked) {
                    el.click();
                }
                if (index == value) {
                    el.click();
                }
            }
        };

        regionSelect.current.addEventListener('change', handleRegionChange);
        incidentTypeRadio.current.addEventListener('change', typeChange);

        if (typeof window !== 'undefined') {
            const hammer = new Hammer(mapControls.current);
            hammer.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });

            hammer.on('swipeleft', function (ev) {
                if (!controlsCollapsed.current) {
                    handleCollapse();
                }
            });
            hammer.on('swiperight', function (ev) {
                if (controlsCollapsed.current) {
                    handleCollapse();
                }
            });
        }

        return () => {
            if (incidentTypeRadio.current && regionSelect.current) {
                incidentTypeRadio.current.removeEventListener('change', typeChange);
                regionSelect.current.removeEventListener('change', handleRegionChange);
            }
        };
    }, []);

    const handleCollapse = (e) => {
        //Is collapsed
        if (!mapControls.current) return;
        if (controlsCollapsed.current) {
            gsap.to(mapControls.current, { translateX: 0, duration: 0.1, ease: 'power3.out' });
            gsap.set(toggleButton.current, { scaleX: 1 });
            gsap.set(mapControls.current, { overflow: 'auto' });
        } else {
            const controlsWidth = mapControls.current.offsetWidth;
            gsap.to(mapControls.current, { translateX: -controlsWidth + 30, duration: 0.1, ease: 'power3.out' });
            gsap.set(toggleButton.current, { scaleX: -1 });
            gsap.set(mapControls.current, { overflow: 'hidden' });
            mapControls.current.scrollTop = 0;
        }

        controlsCollapsed.current = !controlsCollapsed.current;
    };

    return (
        <>
            <div className="u-sr-only">
                <h1 id="main-content" tabIndex="-1">
                    Incidents
                </h1>
                <table>
                    <caption>Summary of incident types in WA</caption>
                    <thead>
                        <tr>
                            <th>Incident type</th>
                            <th>Incident amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {incidentsData &&
                            incidentsData.length > 0 &&
                            incidentsData.map((category, index) => {
                                // if (index > 1) return null;

                                return (
                                    <tr key={index + category.id}>
                                        <td>{category.label}</td>
                                        <td>{category.incidents.length}</td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>
            <div className="incidents-map" aria-hidden>
                <div className="map-controls" ref={mapControls}>
                    <h1 className="h2">Incidents map</h1>
                    <h2 className="h3" label>
                        Choose region
                    </h2>
                    <div className="select">
                        <label className="u-sr-only">Select a region</label>
                        <select ref={regionSelect}>
                            {regions.map((region, index) => (
                                <option key={index} value={region.value}>
                                    {region.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <h2 className="h3">Choose incident type</h2>
                    <div className={`map-controls__incidents`} ref={incidentTypeRadio}>
                        {incidentsData &&
                            incidentsData.length > 0 &&
                            incidentsData.map((category, index) => {
                                // if (index > 1) return null;

                                return (
                                    <CategoryRadio
                                        key={index + category.id}
                                        id={category.id}
                                        value={index}
                                        label={category.label}
                                        count={category.incidents.length}
                                        activeCategory={activeCategory}
                                    />
                                );
                            })}
                    </div>
                    <button
                        className="map-controls__toggle"
                        aria-label="Toggle map control panel"
                        onClick={handleCollapse}
                        ref={toggleButton}
                    >
                        <Icons.AngleRight />
                    </button>
                </div>

                <Map center={initialPosition} zoom={initialZoom} maxZoom={20} preferCanvas={true} zoomControl={false} ref={map}>
                    <LayersControl>
                        {typeof window !== 'undefined' && <GoogleLayer googlekey={key} maptype="ROADMAP" styles={MapStyles} />}
                        {incidentsData.map((category, index) => {
                            return (
                                <LayersControl.Overlay checked={category.id === activeCategory} key={category.id} name={category.label}>
                                    <Incidents label={category.label} id={category.id} incidents={category.incidents} />
                                </LayersControl.Overlay>
                            );
                        })}
                    </LayersControl>
                </Map>

                {/* {MapContainer && (
                    <MapContainer incidentsData={incidentsData} zoom={initialZoom} position={initialPosition} activeCategory={activeCategory} />
                )} */}
            </div>
        </>
    );
};
